var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { VetsStatus } from "./VetsState";
import { VETS_RESET_ACTION_TYPE, VETS_FETCH_START_ACTION_TYPE, VETS_FETCH_SUCCESS_ACTION_TYPE, VETS_GET_START_ACTION_TYPE, VETS_GET_SUCCESS_ACTION_TYPE, VETS_SAVE_START_ACTION_TYPE, VETS_SAVE_SUCCESS_ACTION_TYPE, VETS_ERROR_ACTION_TYPE, } from "../action/VetsActionsTypes";
var initialState = {
    list: [],
    savedVet: undefined,
    vet: undefined,
    status: VetsStatus.Initial,
    loading: false,
};
export var vetsReducer = function (state, action) {
    var _a;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case VETS_RESET_ACTION_TYPE:
            return __assign({}, initialState);
        case VETS_FETCH_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: VetsStatus.Fetching, loading: true });
        case VETS_FETCH_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { list: __spreadArray([], action.payload.vets, true), status: VetsStatus.FetchSuccess, loading: false });
        case VETS_GET_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: VetsStatus.Getting, loading: true, vet: undefined });
        case VETS_GET_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { list: state.list.map(function (v) { return v.uuid === action.payload.vet.uuid ? action.payload.vet : v; }), status: VetsStatus.GetSuccess, vet: __assign({}, action.payload.vet), loading: false });
        case VETS_SAVE_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: VetsStatus.Saving, loading: true, savedVet: undefined });
        case VETS_SAVE_SUCCESS_ACTION_TYPE:
            var vets = state.list.some(function (p) { return p.uuid === action.payload.vet.uuid; })
                ? state.list.map(function (p) { return p.uuid === action.payload.vet.uuid ? action.payload.vet : p; })
                : __spreadArray(__spreadArray([], state.list, true), [action.payload.vet], false);
            return __assign(__assign({}, state), { list: vets, status: VetsStatus.SaveSuccess, loading: false, savedVet: __assign({}, action.payload.vet), vet: (((_a = state.vet) === null || _a === void 0 ? void 0 : _a.uuid) === action.payload.vet.uuid ? __assign({}, action.payload.vet) : state.vet) });
        case VETS_ERROR_ACTION_TYPE:
            return __assign(__assign({}, state), { status: VetsStatus.Error, loading: false });
        default:
            return state;
    }
};
export default vetsReducer;
